import React from "react"
import "./DHeader.css"
import { TypeAnimation } from 'react-type-animation'

const DHeader = () => {
  return (
    <>
      <div className="mt-[110px]">
        <div className="gdheader-top">
          <div className="gdheader">
            <div className="gdheader-logo">
              <img src="./DowntownPhotos/Header/logo.png" alt="" />
            </div>
            <div className="gdheader-content">
              {/* <h3>Gracia Downtown, A Lifestyle Beyond Luxury</h3>
            <p>
              Residential Apartments Located in the Heart of Bahria Town, Lahore.
            </p> */}
              <TypeAnimation
                className="SRheading"
                sequence={[
                  `Swiss Residences,\nA Lifestyle Beyond Luxury`,
                  20000
                ]}
                speed={200}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />
              <TypeAnimation
                className="des"
                sequence={[
                  `First Swiss Residences in Bahria Town Lahore`,
                  20000
                ]}
                speed={150}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />
            </div>
          </div>
        </div>
        <div className="gdheadermobileview">
          <div className="gdheadermobileview-img">
            <img src="./DowntownPhotos/Header/headermb.jpg" alt="building" />
          </div>
          <div className="gdheadermobileview-content">
            {/* <h3>Gracia Downtown, A Lifestyle Beyond Luxury</h3>
          <p>
            Residential Apartments Located In The Heart of Bahria Town, Lahore.
          </p> */}
            <TypeAnimation
              className="SRmobileviewheading"
              sequence={[
                `Swiss Residences,\nA Lifestyle Beyond\nLuxury`,
                20000
              ]}
              speed={200}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
            <TypeAnimation
              className="mobileviewdes"
              sequence={[
                `First Swiss Residences in Bahria Town Lahore.`,
                20000
              ]}
              speed={150}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
          </div>
        </div>
      </div>
    </>

  )
}

export default DHeader
